import React, { Suspense, lazy } from 'react';

// Lazy-load Dataland components to improve initial load time
const DatalandDashboard = lazy(() => import('../dataland-wrapper/DatalandDashboard.js'));

function PartnerPortal({ onBackClick, supabaseClient }) {
  console.log('PartnerPortal component rendered');
  return (
    <section className="min-h-screen bg-gray-900 text-white p-8">
      <button onClick={onBackClick} className="mb-8 text-green-400 hover:text-green-300">
        <i className="fas fa-arrow-left mr-2"></i> Back to Home
      </button>
      
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-4xl font-bold">Partner ESG Portal</h1>
      </div>
      
      {/* Lazy load Dataland UI with loading state */}
      <Suspense fallback={
        <div className="flex justify-center items-center h-64">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-t-green-500 border-r-transparent border-b-green-500 border-l-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-gray-300">Loading ESG dashboard...</p>
          </div>
        </div>
      }>
        <div className="max-w-5xl mx-auto bg-gray-800 p-6 rounded-lg shadow-lg">
          <DatalandDashboard 
            supabaseClient={supabaseClient}
          />
        </div>
      </Suspense>
    </section>
  );
}

export default PartnerPortal;
